import { useQuery } from "@apollo/client";
import { createContext, ReactNode, useContext, useMemo } from "react";
import { GET_COMPLETED_TIPS } from "../api/get-completed-tips";
import { useUser } from "@/application/providers/user";

type ContextProps = {
  isToursCompleted: (tipKey: string) => boolean;
};

const Context = createContext<ContextProps>({
  isToursCompleted: () => false,
});

export function ToursProvider({ children }: { children: ReactNode }) {
  const user = useUser();

  const { data } = useQuery(GET_COMPLETED_TIPS, {
    skip: !user?.id,
  });

  const toursMap = useMemo(() => {
    return (data?.getCompletedTips ?? []).reduce(
      (map, { tipKey, value }) => {
        map[tipKey] = value;
        return map;
      },
      {} as Record<string, string | null | undefined>,
    );
  }, [data?.getCompletedTips]);

  const isToursCompleted = (tipKey: string) => toursMap[tipKey] !== undefined;

  if (!data) {
    return null;
  }

  return (
    <Context.Provider
      value={{
        isToursCompleted,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export function useTours() {
  return useContext(Context);
}
